import {
  Badge,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
} from '@mui/material';
import { ArrowsClockwiseIcon } from '@phosphor-icons/react/dist/ssr/ArrowsClockwise';
import { vars } from '@tgtg/kit';
import useNumberOfPendingDonations from 'features/remote-collection/hooks/useNumberOfPendingDonations';
import { FormattedMessage } from 'react-intl';
import { NavLink } from 'react-router';
import TGTGLogoIcon from 'ui/SvgIcon/icons/TGTGLogoIcon';

import msg from '../messages';

import UserMenu from './UserMenu';

const BaseDrawer = () => {
  const numberOfDonationsToConfirm = useNumberOfPendingDonations();

  return (
    <Stack
      component='nav'
      direction='column'
      spacing={vars.spacing.neutral.xxlarge}
      sx={{
        minHeight: '100vh',
        width: 280,
        paddingX: vars.spacing.neutral.large,
        paddingY: vars.spacing.neutral.xxlarge,
        boxSizing: 'border-box',
      }}
    >
      <Stack sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <TGTGLogoIcon width={72} height={72} />
      </Stack>
      <Stack
        direction='column'
        spacing={vars.spacing.neutral.xxlarge}
        sx={{ justifyContent: 'space-between', flex: 1 }}
      >
        <List disablePadding>
          <ListItem
            disablePadding
            sx={{
              borderRadius: vars.radius.medium,
              color: vars.color.content.brand,
              overflow: 'hidden',
            }}
          >
            <ListItemButton
              component={NavLink}
              to='/'
              sx={{
                '&.active': {
                  backgroundColor: vars.color.surface.interactive.opacityOverlayPressed,
                },
                '&:hover': {
                  backgroundColor: vars.color.surface.interactive.opacityOverlayHover,
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: `calc(18px + ${vars.spacing.neutral.large})` }}>
                <Badge
                  badgeContent={numberOfDonationsToConfirm}
                  sx={{
                    ['& .MuiBadge-badge']: {
                      top: '5px',
                      right: '3px',
                    },
                  }}
                >
                  <ArrowsClockwiseIcon
                    style={{
                      color: vars.color.content.brand,
                      width: vars.size.medium,
                      height: vars.size.medium,
                    }}
                  />
                </Badge>
              </ListItemIcon>
              <ListItemText
                primary={<FormattedMessage {...msg.collectionStatus} />}
                primaryTypographyProps={{
                  fontWeight: 500,
                  fontFamily: vars.typography.labels.medium.fontFamily,
                  fontSize: vars.typography.labels.medium.fontSize,
                }}
              />
            </ListItemButton>
          </ListItem>
        </List>
        <UserMenu />
      </Stack>
    </Stack>
  );
};

export default BaseDrawer;
